module.exports = __webpack_public_path__ + "static/img/064_TO8_1624_og.3db2c99.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/064_TO8_1624_og.jpg
// module id = gewT
// module chunks = 0